<div *ngIf="prikaziStranicu" class="container-fluid">
  <h2 class="content-block">SKLADIŠTE HLAD</h2>
  <div class="content-block dnevniPlanWrapper skladiste">
    <div class="selectDates">
      <div class="odabirDatuma">
        <label>Datum od:</label>
        <dx-date-box
          [(value)]="datumOd"
          [(max)]="datumDo"
          pickerType="calendar"
          displayFormat='dd.MM.yyyy.'
          width="200"
          (onValueChanged)="onValueChangedDatumOd($event)"
        >
        </dx-date-box>
      </div>
      <div class="odabirDatuma" style="margin-right: 30px">
        <label>Datum do:</label>
        <dx-date-box
          [(value)]="datumDo"
          [(min)]="datumOd"
          pickerType="calendar"
          displayFormat='dd.MM.yyyy.'
          width="200"
          (onValueChanged)="onValueChangedDatumDo($event)"
        >
        </dx-date-box>
      </div>
      <div class="odabirDatuma">
        <dx-button
          class="btn_trazi"
          [disabled]="disableGumb"
          stylingMode="contained"
          text="Prikaži"
          type="success"
          [width]="120"
          (onClick)="pretrazi()">
        </dx-button>
      </div>
    </div>
    <div class="customTable dnevniPlan">
      <dx-data-grid
        #tablicaDnevniPlan
        id="gridContainer"
        [dataSource]="tablica"
        [showColumnLines]="true"
        [wordWrapEnabled]="true"
        noDataText="{{ poruka }}"
        keyExpr="idlot"
        [showBorders]="false"
        (onRowClick)="trenutnaRoba($event)"
        (onCellClick)="onCellClick($event)"
        (onToolbarPreparing)="onToolbarPreparing($event)"
      >
        <div *dxTemplate="let data of 'naslovTablice'" class="grid-wrapper">
          <div class="naslov">
            <h2 class="mb-0">Skladište Hlad</h2>
          </div>
        </div>

        <dxo-search-panel
          [visible]="true"
          [width]="210"
          placeholder="Pretraži..."
        >
        </dxo-search-panel>

        <dxo-paging [enabled]="true" [pageSize]="10"></dxo-paging>

        <dxo-pager
          [showPageSizeSelector]="true"
          [allowedPageSizes]="[10, 20, 30]"
          [showInfo]="true"
        >
        </dxo-pager>

        <dxi-column
          dataField="sifra"
          caption="Šifra"
          [width]="100"
          alignment="center"
        ></dxi-column>
        <dxi-column
          dataField="lot"
          caption="LOT"
          [width]="100"
          alignment="center"
        ></dxi-column>
        <dxi-column
          dataField="datum"
          caption="Datum"
          [width]="150"
          alignment="center"
        ></dxi-column>
        <dxi-column
          dataField="naziv"
          caption="Naziv"
          [allowEditing]="false"
        ></dxi-column>
        <dxi-column
          dataField="ulaz"
          caption="Ulaz"
          [width]="100"
          alignment="center"
        ></dxi-column>
        <dxi-column
          dataField="izlaz"
          caption="Izlaz"
          [width]="100"
          alignment="center"
        ></dxi-column>
        <dxi-column
          dataField="razlika"
          caption="Stanje"
          [width]="100"
          alignment="center"
        ></dxi-column>

        <dxo-master-detail
          [enabled]="true"
          template="detail"
        ></dxo-master-detail>
        <div *dxTemplate="let data of 'detail'" class="trenutno">
          <dx-data-grid
            [dataSource]="promet"
            [showColumnLines]="true"
            [wordWrapEnabled]="true"
            keyExpr="idlot"
            noDataText="{{ poruka }}"
            [showBorders]="false"
          >
            <dxi-column
              dataField="lot"
              caption="LOT"
              [width]="100"
              alignment="center"
            ></dxi-column>
            <dxi-column
              dataField="datum"
              caption="Datum"
              [width]="150"
              alignment="center"
            ></dxi-column>
            <dxi-column
              dataField="dokBroj"
              caption="Dok. broj"
              [width]="80"
              alignment="center"
            ></dxi-column>
            <dxi-column
              dataField="dokVrsta"
              caption="Vrsta dok."
              [width]="100"
              alignment="center"
            ></dxi-column>
            <dxi-column
              dataField="ulaz"
              caption="Ulaz"
              [width]="100"
              alignment="center"
            ></dxi-column>
            <dxi-column
              dataField="izlaz"
              caption="Izlaz"
              [width]="100"
              alignment="center"
            ></dxi-column>
            <dxi-column
              dataField="stanje"
              caption="Stanje"
              [width]="100"
              alignment="center"
            ></dxi-column>
            <dxi-column
              dataField="komora"
              caption="Komora"
              [width]="100"
              alignment="center"
            ></dxi-column>
            <dxi-column
              dataField="red"
              caption="Red"
              [width]="100"
              alignment="center"
            ></dxi-column>
            <dxi-column
              dataField="strana"
              caption="Strana"
              [width]="100"
              alignment="center"
            ></dxi-column>
          </dx-data-grid>
        </div>
      </dx-data-grid>
    </div>
  </div>
</div>
